import { render, staticRenderFns } from "./Tuijian.vue?vue&type=template&id=4e012236&"
import script from "./Tuijian.vue?vue&type=script&lang=js&"
export * from "./Tuijian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports